import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class TerminalService {

  constructor(private http:HttpClient) { }

  getpnr(pnrNO:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("pnr", pnrNO);
    let request = {"pnrNumber":pnrNO}
      return this.http.post( environment.API_URL+"/api/product/air/_search/pnr/v1",request ,{observe : "body",responseType : "json"})  
  }

  docIssuance(pnrNO:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("pnr", pnrNO);
    let request = {"pnrNumber":pnrNO}
      return this.http.post( environment.API_URL+"/product/air/display/tst/v1",request ,{observe : "body",responseType : "json"})  
  }

  getmopnr(pnrNO:any) {
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("pnr", pnrNO);
    let request = {"pnrNumber":pnrNO}
      return this.http.post( environment.API_URL+"/api/external/midoffice/retreive",httpParam ,{observe : "body",responseType : "json"})  
  }

  updateFOPPNR(fopUpdateRequest:any) {
    let header = new HttpHeaders();
    header.append("Content-Type", "application/json")
    let httpParam : HttpParams=new HttpParams();
   // httpParam=httpParam.append("pnr", pnrNO);
    //let request = {"pnrNumber":pnrNO}
      return this.http.post( environment.API_URL+"/api/external/midoffice/fop_update/v1",fopUpdateRequest ,{headers: header,observe : "body",responseType : "json"})  
  }

  docIssaunce(pnrNO:any) {
    let header = new HttpHeaders();
    header.append("Content-Type", "application/json")
    let httpParam : HttpParams=new HttpParams();
    httpParam=httpParam.append("pnr", pnrNO);
    let request = {"pnrNumber":pnrNO}
      return this.http.post( environment.API_URL+"/api/external/midoffice/doc_issuance/v1",request ,{headers : header,observe : "body",responseType : "json"})  
  }
}
